export const routes = [{
  path: '/medalha',
  component: () =>
    import(/* webpackChunkName: "ur" */ './components/List'),
  name: 'medalha.list',
  meta: {
    requiresAuth: true
  }
}]
